import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingStepService } from '../services/booking-step.service';

@Injectable()
export class BookingEventSlotProductsGuard implements CanActivate {

  constructor(
    private bookingStepService: BookingStepService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.bookingStepService.isBookingEventSlotProductsAvailable) {
      return true;
    }

    this.router.navigate(['/booking/events']);
    return false;
  }
}
